import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import classnames from 'classnames';
import { useModal } from '@/providers/modal';
import { MODAL_IDS } from '@/kit/Modal/keys';
import { ModalCenterLayout } from '@/kit/Modal/layouts/center';
import IconArrow from './icon_arrow.svg';
import s from './index.module.scss';

const id = MODAL_IDS.fpg_docs_modal;

export const FpgDocumentsModal = () => {
  const { modalIds } = useModal();
  return modalIds[id] && <Modal />;
};

const Modal = () => {
  const { closeModal } = useModal();
  const { t } = useTranslation('modal');

  const content = (
    <div className={classnames(s.modal, 'scr_modal_grid')}>
      <div className={classnames(s.title, 'f-h2 f-500')}>
        {t('fpg_docs_modal.asset_evidence_documents')}
      </div>
      <div className={s.content}>
        <Dropdown title={t('fpg_docs_modal.cash_cash_equivalents')}>
          <ul>
            <li>{t('fpg_docs_modal.bank_statements')}</li>
            <li>{t('fpg_docs_modal.bank_proof_of_funds')}</li>
            <li>{t('fpg_docs_modal.nsi_statements')}</li>
          </ul>
        </Dropdown>
        <Dropdown title={t('fpg_docs_modal.investments')}>
          <ul>
            <li>{t('fpg_docs_modal.broker_statements')}</li>
          </ul>
        </Dropdown>
        <Dropdown title={t('fpg_docs_modal.real_estate')}>
          <>
            <div>{t('fpg_docs_modal.for_each_property')}</div>
            <ul>
              <li>{t('fpg_docs_modal.official_copy')}</li>
              <li>{t('fpg_docs_modal.independent_valuation')}</li>
              <li>{t('fpg_docs_modal.latest_mortgage_statement')}</li>
            </ul>
          </>
        </Dropdown>
        <Dropdown title={t('fpg_docs_modal.vehicles')}>
          <ul>
            <li>{t('fpg_docs_modal.proof_of_purchase')}</li>
            <li>{t('fpg_docs_modal.finance_agreement')}</li>
          </ul>
        </Dropdown>
        <Dropdown title={t('fpg_docs_modal.shares_interests')}>
          <ul>
            <li>{t('fpg_docs_modal.private_uk_companies')}</li>
            <li>{t('fpg_docs_modal.public_holdings')}</li>
          </ul>
        </Dropdown>
        <Dropdown title={t('fpg_docs_modal.loans_receivable')}>
          <ul>
            <li>{t('fpg_docs_modal.executed_loan_agreements')}</li>
            <li>{t('fpg_docs_modal.bank_evidence')}</li>
            <li>{t('fpg_docs_modal.debtor_confirmation')}</li>
          </ul>
        </Dropdown>
        <Dropdown title={t('fpg_docs_modal.life_policies')}>
          <ul>
            <li>{t('fpg_docs_modal.insurer_statement')}</li>
          </ul>
        </Dropdown>
        <Dropdown title={t('fpg_docs_modal.trust_interests')}>
          <ul>
            <li>{t('fpg_docs_modal.trust_deed')}</li>
            <li>{t('fpg_docs_modal.trustee_letter')}</li>
          </ul>
        </Dropdown>
        <Dropdown title={t('fpg_docs_modal.intellectual_property')}>
          <ul>
            <li>{t('fpg_docs_modal.extracts_registration')}</li>
          </ul>
        </Dropdown>
        <Dropdown title={t('fpg_docs_modal.precious_metals')}>
          <ul>
            <li>{t('fpg_docs_modal.independent_valuation_precious')}</li>
            <li>{t('fpg_docs_modal.provenance_documents')}</li>
          </ul>
        </Dropdown>
        <Dropdown title={t('fpg_docs_modal.cryptoassets')}>
          <ul>
            <li>{t('fpg_docs_modal.exchange_statements')}</li>
            <li>{t('fpg_docs_modal.self_custody')}</li>
          </ul>
        </Dropdown>
        <Dropdown title={t('fpg_docs_modal.overseas_assets')}>
          <ul>
            <li>{t('fpg_docs_modal.local_equivalents')}</li>
          </ul>
        </Dropdown>
        <Dropdown title={t('fpg_docs_modal.liabilities')}>
          <ul>
            <li>{t('fpg_docs_modal.mortgage_statements')}</li>
          </ul>
        </Dropdown>
      </div>
    </div>
  );

  return (
    <ModalCenterLayout id={id} onClose={() => closeModal(id)} showClose>
      {content}
    </ModalCenterLayout>
  );
};

const Dropdown = ({ title, children }) => {
  const [open, setOpen] = useState(false);

  return (
    <div className={s.row} onClick={() => setOpen(!open)}>
      <div className={s.header}>
        <div className={s.label}>{title}</div>
        <img
          src={IconArrow}
          alt="arrow"
          width={16}
          height={16}
          style={{ transform: `rotate(${open ? '180deg' : '0'})` }}
        />
      </div>
      <div className={classnames(s.dropdown, open && s.dropdown_active)}>
        <div className={classnames(s.answer, 'f-label')}>{children}</div>
      </div>
    </div>
  );
};
